import React, { useEffect, useState } from 'react';
import '../../Css/DashboardSubmenu.css';
import { Link,  useNavigate, } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../../Middleware/Firebase/firebase';
import { collection, onSnapshot, query } from 'firebase/firestore';

function DashboardSideBarMenu() {
  const [company, setCompany] = useState(null);
  const [sino, setSino] = useState([]);
  const navigate=useNavigate()


//------------------------Ordem State-------------

function OrdemState(value){

if(value==="Exit") {
  navigate("/");
   setCompany(null);}
}


  // ------------------ AUTH LISTENER ---------------------
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (currentUser) => {
      setCompany(currentUser);
    });
    return () => unsub();
  }, []);

  // ------------------ REALTIME ORDER LISTENER ---------------------
  useEffect(() => {
    if (!company?.uid) return;

    const q = query(collection(db, "orders"));
    const unsubOrders = onSnapshot(q, (snapshot) => {
      const orders = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));

      // filtrar items do supplier logado com status "Pending"
      const pendingItems = [];

      orders.forEach((order) => {
        const basket = Array.isArray(order?.items?.basket)
          ? order.items.basket
          : [];

        const supplierPending = basket.filter(
          (item) =>
            item?.idSupplier === company.uid &&
            item?.status === "Pending"
        );

        if (supplierPending.length > 0) {
          pendingItems.push(...supplierPending);
        }
      });

      setSino(pendingItems);
    });

    return () => unsubOrders();
  }, [company]);

  // ------------------ UI ---------------------
  return (
    <aside className="sidebar">
      {/* HEADER */}
      <div className="sideheader">
        <select onChange={(e)=>{OrdemState(e.target.value)}} className="selectheader">
          <option value={company?.email} >{company?.email || 'Conta'}</option>
          <option>Definições</option>
          <option value={"Exit"} >Log Out</option>
        </select>

        <Link className="elementsidecontain" to="/MNGMT/Search/Produto">
          🔍 Pesquisar
        </Link>

        {sino.length > 0 ? (
          <Link to="/MNGMT/Order/Produto/2day">
            <div className="elementsidecontain bg-gray-300 flex justify-between">
              <span>🔔 Notificações</span>
              <span className="text-red-600 font-bold">{sino.length}</span>
            </div>
          </Link>
        ) : (
          <div className="elementsidecontain text-gray-400">
            🔕 Sem Pedidos
          </div>
        )}

        <Link to={`/MNGMT/Profile/${company?.uid}`}>
          <div className="elementsidecontain">
            ⚙️ Perfil
          </div>
        </Link>
      </div>

      {/* BODY */}
      <div className="sidebarBody">
        <nav className="SideMenu">
          <Link className="elementsidecontain" to="/MNGMT/Business/Facturas">
            💳 Facturar
          </Link>

          <Link to="/MNGMT/Business/Vendas">
            <div className="submenu-title">📦 Vendas</div>
          </Link>

          <ul className="submenu-list">
            <li>📊 Estatística</li>
            <li>
              <Link to="">
                👥 Clientes
              </Link>
            </li>
            <li> 💳 Fecho</li>
          </ul>

          <Link className="elementsidecontain" to="/MNGMT/Del/Produto">
            🗑️ Apagar Produtos
          </Link>

          <Link className="elementsidecontain" to="/MNGMT/Order/Produto">
            📦 Pedidos
          </Link>
        </nav>

        <nav className="sidesubmenu">
          <Link className="elementsidecontain" to="/MNGMT/Update/Produto">
            ✏️ Atualizar Produto
          </Link>

          <Link className="elementsidecontain" to="/MNGMT/Add/Produto">
            ➕ Adicionar Produto
          </Link>

          <Link className="elementsidecontain" to="/MNGMT/Ads/Produto">
            ➕ Adicionar ADS
          </Link>

          <Link className="elementsidecontain" to="/MNGMT/Search/Produto">
            📋 Consulta
          </Link>

          <div className="elementsidecontain">
            ⚖️ Balance
          </div>
        </nav>
      </div>

      {/* FOOTER */}
      <div className="sidefoot">
        <div className="footcontain">
          <div className="divImg">
            <img src={company?.img} alt="user" />
          </div>

          <div className="divuser">
            <h5>ID Utilizador</h5>
            <span>{company?.uid}</span>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default DashboardSideBarMenu;